import React, { useEffect, useState } from 'react'
import Proxies from 'Components/proxies'
import DynamicTable from 'Components/dynamicTable'
import CollapsibleCard from 'Components/collapsibleCard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { Button, ButtonGroup, UncontrolledTooltip as Tooltip } from 'reactstrap'

export default function ScheduledJobsOverview() {
  const [scheduledJobs, setScheduledJobs] = useState([])
  const [loading, setLoading] = useState(false)
  const [scheduledJobFilterValue, setScheduledJobFilterValue] = useState('active')

  useEffect(() => {
    setLoading(true)
    getScheduledJobs()
  }, [])

  function getScheduledJobs() {
    Proxies.GET('scheduledJobs/pool').then(responseJSON => {
      if (responseJSON.error) {
        // console.log(responseJSON.error)
      } else {
        setScheduledJobs(responseJSON)
      }
      setLoading(false)
    })
  }
  function deleteScheduledJob(scheduledJob) {
    setLoading(true)
    Proxies.POST('scheduledJobs/removeJob', scheduledJob).then(responseJSON => {
      if (responseJSON.error) {
        // console.log(responseJSON.error)
      } else {
        getScheduledJobs()
      }
      setLoading(false)
    })
  }

  return (
    <CollapsibleCard
      startOpen
      header={
        <strong>
          ScheduledJobs
          <ButtonGroup className='float-right'>
            <Button
              outline
              scheduledJob='success'
              onClick={() => setScheduledJobFilterValue(scheduledJobFilterValue === 'active' ? 'both' : 'active')}
              active={scheduledJobFilterValue === 'active'}
            >
              Active
            </Button>
            <Button
              outline
              scheduledJob='danger'
              onClick={() => setScheduledJobFilterValue(scheduledJobFilterValue === 'inactive' ? 'both' : 'inactive')}
              active={scheduledJobFilterValue === 'inactive'}
            >
              In-Active
            </Button>
            <Button style={{ marginLeft: 8 }} tag={Link} to={'/scheduledJobs/new'}>
              Opret
            </Button>
          </ButtonGroup>
        </strong>
      }
    >
      {loading ? (
        <FontAwesomeIcon icon='spinner' spin />
      ) : (
        <DynamicTable
          responsive
          size='sm'
          options={{
            startSort: {
              dir: 'DESC',
              column: 'name'
            },
            fieldFunctions: {},
            addField: e => {
              return (
                <td>
                  <ButtonGroup>
                    <Tooltip target={'edit' + e.ScheduledJobID}>Rediger</Tooltip>
                    <Button tag={Link} to={'/scheduledJobs/' + e.ScheduledJobID} id={'edit' + e.ScheduledJobID}>
                      <FontAwesomeIcon icon='edit' />
                    </Button>
                    {e.removed === 0 && (
                      <React.Fragment>
                        <Tooltip target={'deactivate' + e.ScheduledJobID}>Deaktivér</Tooltip>
                        <Button
                          id={'deactivate' + e.ScheduledJobID}
                          onClick={() => {
                            if (confirm('Vil du deaktivere denne ScheduledJob?')) {
                              deleteScheduledJob({ ScheduledJobID: e.ScheduledJobID, removed: 1 })
                            }
                          }}
                        >
                          <FontAwesomeIcon icon='user-check' />
                        </Button>
                      </React.Fragment>
                    )}
                    {e.removed === 1 && (
                      <React.Fragment>
                        <Tooltip target={'actiavte' + e.ScheduledJobID}>Aktivér</Tooltip>
                        <Button
                          id={'actiavte' + e.ScheduledJobID}
                          scheduledJob='danger'
                          onClick={() => {
                            if (confirm('Vil du aktivere denne ScheduledJob?')) {
                              deleteScheduledJob({ ScheduledJobID: e.ScheduledJobID, removed: 0 })
                            }
                          }}
                        >
                          <FontAwesomeIcon icon='user-slash' />
                        </Button>
                      </React.Fragment>
                    )}
                  </ButtonGroup>
                </td>
              )
            }
          }}
          headers={{
            ScheduledJobID: '#',
            description: 'Description',
            cronString: 'Cron String',
            endpoint: 'Endpoint',
            payload: 'Payload'
          }}
          data={
            scheduledJobs && scheduledJobFilterValue !== 'both' && !!scheduledJobs.length
              ? scheduledJobs.filter(scheduledJob => scheduledJob.removed === (scheduledJobFilterValue === 'inactive' ? 1 : 0))
              : scheduledJobs
          }
        />
      )}
    </CollapsibleCard>
  )
}
